export enum MaterialInOutSourceType {
  WORK_ORDER = "WORK_ORDER",
  PETTY_WORK = "PETTY_WORK",
  AMC = "AMC",
  OTHER = "OTHER",
}

export const MaterialInOutSourceTypeLabel: Record<
  MaterialInOutSourceType,
  string
> = {
  [MaterialInOutSourceType.WORK_ORDER]: "Work Order",
  [MaterialInOutSourceType.PETTY_WORK]: "Petty Work",
  [MaterialInOutSourceType.AMC]: "AMC",
  [MaterialInOutSourceType.OTHER]: "Other",
};
